<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import { getNow } from "../data/clock";

  export let time = getNow();

  let timer = null;
  const TICK = 30000;

  function stopTicking() {
    clearInterval(timer);
    timer = null;
  }

  function startTicking() {
    let lastTime = new Date();
    timer = setInterval(function () {
      // Update the timer by getting the difference in time between
      // the last interval and now.
      //
      // IMPORTANT: We can't just add 1000ms, setInterval grants no
      // gaurantee about how much time has passed, just that the time
      // limit has expired.
      const nextTime = new Date();
      const elapsedTime = nextTime.getTime() - lastTime.getTime();

      lastTime = nextTime;

      time.update(($time) => {
        return new Date($time.getTime() + elapsedTime);
      });
    }, TICK);
  }

  onMount(startTicking);
  onDestroy(stopTicking);
</script>

<svelte:window on:offline={stopTicking} on:online={startTicking} />
